import { useState } from "react";
import { useAuth, useLoad } from "../lib/api.jsx";
import { Wait, Tbl, csv, money, day, subTag } from "../lib/ui.jsx";

export default function Subscriptions({ mode }) {
  const { act } = useAuth();
  const [f, setF] = useState({ search: "", status: "", expiring: "", from: "", to: "" });
  const [d, reload] = useLoad("subs", f);
  const total = (d?.rows || []).filter((s) => s.status === 1)
    .reduce((a, s) => ({ ...a, [s.paid_currency]: (a[s.paid_currency] || 0) + +s.paid_amount }), {});

  return (
    <>
      <h1>{mode === "pay" ? "Payments" : "Subscriptions"}</h1>
      <div className="bar">
        <input placeholder="Search user, order, transaction" value={f.search} onChange={(e) => setF({ ...f, search: e.target.value })} />
        <select value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })}>
          <option value="">Any state</option><option value="1">Active</option><option value="2">Cancelled</option>
        </select>
        {mode === "subs" && (
          <label className="chk">
            <input type="checkbox" checked={f.expiring === "1"} onChange={(e) => setF({ ...f, expiring: e.target.checked ? "1" : "" })} />
            Expiring in 7 days
          </label>
        )}
        {mode === "pay" && (
          <>
            <input type="date" value={f.from} onChange={(e) => setF({ ...f, from: e.target.value })} />
            <input type="date" value={f.to} onChange={(e) => setF({ ...f, to: e.target.value })} />
          </>
        )}
        <button className="btn g" onClick={() => d?.rows && csv(mode, d.rows)}>Export CSV</button>
      </div>
      {mode === "pay" && <p>Collected in this view: {Object.entries(total).map(([c, t]) => money(t, c)).join(" + ") || "0"}</p>}
      <Wait d={d}>
        {d && !d.error && (
          <Tbl rows={d.rows} empty="No records match." cols={mode === "pay" ? [
            ["Date", (s) => day(s.created_at)], ["Order", (s) => s.orderId], ["User", (s) => s.Name || s.user_id],
            ["Package", (s) => s.p_name], ["Method", (s) => s.method], ["Transaction", (s) => s.trxId || "-"],
            ["Amount", (s) => money(s.paid_amount, s.paid_currency)], ["State", subTag],
          ] : [
            ["User", (s) => s.Name || s.user_id], ["Service", (s) => s.portal], ["Package", (s) => s.p_name],
            ["Start", (s) => day(s.startDate)], ["End", (s) => day(s.endDate)], ["State", subTag],
            ["", (s) => (
              <button className={"btn s " + (s.status === 1 ? "d" : "g")} onClick={() => act("sub_status", { id: s.id, status: s.status === 1 ? 2 : 1 }, "Updated.").then(reload)}>
                {s.status === 1 ? "Cancel" : "Reactivate"}
              </button>
            )],
          ]} />
        )}
      </Wait>
    </>
  );
}
